import * as React from 'react';
import { Edit } from 'react-admin';
import { RegionForm,  } from './RegionForm';
import { RecordEditTitle } from '../../components/RecordTitle';
import { transformMediaUrlInput } from '../../lib/media/makeUrl';

export const RegionEdit = (props: any) => {
    const transform = data => ({
      ...data,
      mediaUrl: transformMediaUrlInput(data.mediaUrl)
    });
  return (
    <Edit title={<RecordEditTitle />} {...props} transform={transform}>
      <RegionForm />
    </Edit>
  );
}
